import rewards from '../../../services/rewards.service'
import { claimConstants } from '../../constants'

const RECEIVE_MY_REWARDS = 'app/myRewards/RECEIVE_MY_REWARDS'
const RECEIVE_MY_REWARD_ARCHIVE = 'app/myRewards/RECEIVE_MY_REWARDS_ARCHIVE'

export const loadMyRewards = language => dispatch =>
  rewards.loadMyRewards(language).then(myRewards =>
    dispatch({
      type: RECEIVE_MY_REWARDS,
      myRewards,
    })
  )

export const loadMyArchive = language => dispatch =>
  rewards.loadMyArchive(language).then(myArchive =>
    dispatch({
      type: RECEIVE_MY_REWARD_ARCHIVE,
      myArchive,
    })
  )

export const myRewards = state => state.myRewardsReducer

const defaultState = {
  rewards: [],
  archive: [],
  rewardsLoaded: false,
  archiveLoaded: false,
}

export default function myRewardsReducers(state, action) {
  const currentState = state || defaultState

  switch (action.type) {
    case RECEIVE_MY_REWARDS: {
      return {
        ...currentState,
        rewards: action.myRewards,
        rewardsLoaded: true,
      }
    }
    case RECEIVE_MY_REWARD_ARCHIVE:
      return {
        ...currentState,
        archive: action.myArchive,
        archiveLoaded: true,
      }
    case claimConstants.CLAIM_SUCCESS:
      return {
        ...currentState,
        rewardsLoaded: false,
      }
    default:
      return currentState
  }
}
